import { library } from '@fortawesome/fontawesome-svg-core';

// Import only the specific solid icons used in the application
import { 
  faArrowRight, 
  faArrowUp,
  faBars,
  faBrain,
  faBuilding,
  faCalendarCheck,
  faChartLine,
  faCheckCircle,
  faChevronDown,
  faCloud,
  faCogs,
  faCommentDots,
  faEnvelope,
  faFileAlt,
  faLandmark,
  faLightbulb,
  faLock,
  faMedal,
  faMinus,
  faMobileAlt,
  faMobileScreen,
  faPalette,
  faPhone,
  faPlus,
  faRobot,
  faSchool,
  faServer,
  faShieldAlt,
  faSpinner,
  faTimes,
  faUser,
  faUserFriends
} from '@fortawesome/free-solid-svg-icons';

// Import only the specific brand icons used in the application
import { 
  faLinkedin, 
  faTwitter, 
  faFacebook 
} from '@fortawesome/free-brands-svg-icons';

// Add only these specific icons to the library
library.add(
  // Solid icons
  faArrowRight,
  faArrowUp,
  faBars,
  faBrain,
  faBuilding,
  faCalendarCheck,
  faChartLine, 
  faCheckCircle,
  faChevronDown,
  faCloud,
  faCogs,
  faCommentDots,
  faEnvelope,
  faFileAlt,
  faLandmark,
  faLightbulb,
  faLock,
  faMedal,
  faMinus,
  faMobileAlt,
  faMobileScreen,
  faPalette,
  faPhone,
  faPlus,
  faRobot,
  faSchool,
  faServer,
  faShieldAlt,
  faSpinner,
  faTimes,
  faUser,
  faUserFriends,
  
  // Brand icons
  faLinkedin,
  faTwitter,
  faFacebook
);

// Export function to initialize the library (to be called once in App.js)
export const initIconLibrary = () => {
  // Library is already initialized above
  // This is just a stub function to make the import explicit
}; 